export default function useVibration() {
  const vibrate = (pattern) => {
    try {
      navigator.vibrate(pattern);
      // eslint-disable-next-line no-empty
    } catch (error) {}
  };

  return {
    vibrate,
  };
}
